import { useEffect } from 'react';

export default function Contact() {

    return (
        <div className="back-container-black pt-1 relative pb-6">
            <h2 className="text-center titles text-300">Contact</h2>
            
            <div className="flex justify-content-center">
                <h3 className="flex justify-content-center mr-3 select-text">cedricjeanjean311@gmail.com</h3>
                <a href="https://www.linkedin.com/in/cjeanjean/" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '1.8rem' }} className="mt-2 linkedin-icon" aria-label="LinkedIn">
                    <i className="pi pi-linkedin" />
                </a>
            </div>
            
        </div>
    )

}